import React from 'react';
import ReactDOM from 'react-dom';
import './styles/main.scss';
import Root from './App';

/** @jsxRuntime classic */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import {common, putEncStorage} from 'src/common/common';
import {countryCodesWithTerms, eSessionKeys} from 'src/common/const';

const isValidCountry = (country) => typeof country === 'string' && /^[A-Za-z]{2}$/.test(country.trim());

const geoCountry = async () => {
  const sources = [
    {url: 'https://ipapi.co/json/', pick: (data) => data.country},
    {url: 'https://api.ip.pe.kr/json/', pick: (data) => data.country_code},
    {url: 'https://api.country.is/', pick: (data) => data.country},
  ];
  for (const source of sources) {
    try {
      const response = await fetch(source.url);
      if (!response.ok) continue;
      const data = await response.json();
      const country = source.pick(data);
      if (isValidCountry(country)) return country.trim().toUpperCase();
    } catch (error) {
      console.log('COUNTRY_CODE_NONE');
    }
  }
  return common.continent.toUpperCase();
};

(async function () {
  const country = await geoCountry();
  if (countryCodesWithTerms.includes(country.toUpperCase())) {
    putEncStorage(eSessionKeys.COUNTRY_CODE, country.toUpperCase());
    putEncStorage(eSessionKeys.SERVER_TYPE, common.serverType);
  } else {
    putEncStorage(eSessionKeys.COUNTRY_CODE, common.continent.toUpperCase());
    putEncStorage(eSessionKeys.SERVER_TYPE, common.serverType);
  }
  ReactDOM.render(<Root />, document.getElementById('root'));
})();
